<template>
  <SmartHrLocalList module-type="CARE" title="员工关怀" group-name="员工关系"/>
</template>
<script>
import SmartHrLocalList from './SmartHrLocalList'
export default {
  name: 'SmartHrCare',
  components: { SmartHrLocalList }
}
</script>



// WEBPACK FOOTER //
// SmartHrCare.vue?065849d0